export default __webpack_public_path__ + "static/media/card-reader.215f9f45.png";